// Each tour owns its gallery state; native buttons provide keyboard activation.
// Exposed as coachPotato.initTourGalleries(root) so cards injected after page load — the
// search result expansion — can be wired up too. Idempotent: already-bound galleries are
// skipped, so calling it again over the whole document is harmless.
(function () {
    "use strict";

    function initTourGalleries(root) {
        (root || document).querySelectorAll("[data-tour-gallery]").forEach(function (gallery) {
        if (gallery.dataset.galleryReady) return;
        var controls = gallery.querySelector("[data-gallery-controls]");
        if (!controls) return;
        gallery.dataset.galleryReady = "true";
        var image = gallery.querySelector("[data-gallery-image]");
        var caption = gallery.querySelector("[data-gallery-caption]");
        var status = gallery.querySelector("[data-gallery-status]");
        var buttons = Array.from(controls.querySelectorAll("[data-gallery-photo]"));

        buttons.forEach(function (button, index) {
            button.addEventListener("click", function () {
                image.alt = button.dataset.alt;
                ["width", "height"].forEach(function (attribute) {
                    if (button.dataset[attribute]) image.setAttribute(attribute, button.dataset[attribute]);
                    else image.removeAttribute(attribute);
                });
                image.src = button.dataset.src;
                caption.textContent = button.dataset.caption;
                status.textContent = "Photo " + (index + 1) + " of " + buttons.length;
                buttons.forEach(function (other) {
                    other.setAttribute("aria-pressed", other === button ? "true" : "false");
                });
            });
        });
        // Only expose controls once they're functional. The first photo needs no JS.
        controls.hidden = false;
        });
    }

    window.coachPotato = window.coachPotato || {};
    window.coachPotato.initTourGalleries = initTourGalleries;
    initTourGalleries(document);
})();

// Progressive enhancement: itinerary photo links remain usable without JavaScript.
(function () {
    "use strict";
    var element = document.getElementById("itinerary-photo-lightbox");
    if (!element || typeof bootstrap === "undefined" || !bootstrap.Modal) return;

    var modal = bootstrap.Modal.getOrCreateInstance(element);
    var title = element.querySelector(".modal-title");
    var close = element.querySelector("[data-bs-dismiss]");
    var dayType = element.querySelector("[data-lightbox-day-type]");
    var dayList = element.querySelector("[data-lightbox-day-list]");
    var details = element.querySelector("[data-lightbox-details]");
    var media = element.querySelector("[data-lightbox-media]");
    var loading = element.querySelector("[data-lightbox-loading]");
    var noPhoto = element.querySelector("[data-lightbox-no-photo]");
    var error = element.querySelector("[data-lightbox-error]");
    var direct = element.querySelector("[data-lightbox-direct]");
    var credit = element.querySelector("[data-lightbox-credit]");
    var previous = element.querySelector("[data-lightbox-previous]");
    var next = element.querySelector("[data-lightbox-next]");
    var status = element.querySelector("[data-lightbox-status]");
    var trigger, activeImage, returnScroll;
    var days = [], dayButtons = [], activeIndex = -1;

    function creditLink(label, url) {
        // Metadata is text, never HTML. Only HTTP(S) attribution links are navigable.
        try {
            var parsed = new URL(url);
            if (parsed.protocol === "https:" || parsed.protocol === "http:") {
                var link = document.createElement("a");
                link.href = parsed.href;
                link.textContent = label;
                link.target = "_blank";
                link.rel = "noopener nofollow";
                return link;
            }
        } catch (_) { /* Missing or invalid URL: keep the credit as plain text. */ }
        return document.createTextNode(label);
    }

    function labelFor(day) {
        return (day.dataset.dayTitle || "").trim() || day.dataset.dayType || "Itinerary";
    }

    function headingFor(day) {
        return "Day " + day.dataset.dayNumber + " — " + labelFor(day);
    }

    function cancelImage() {
        if (!activeImage) return;
        activeImage.onload = activeImage.onerror = null;
        activeImage.removeAttribute("src");
        activeImage = null;
    }

    function showCredit(photo) {
        credit.replaceChildren();
        credit.hidden = !photo || !photo.dataset.lightboxSource;
        if (credit.hidden) return;

        var photographer = photo.dataset.lightboxPhotographer;
        credit.append(document.createTextNode(photographer ? "Photo by " : "Photo on "));
        if (photographer) {
            credit.append(creditLink(photographer, photo.dataset.lightboxPhotographerUrl), document.createTextNode(" on "));
        }
        credit.append(creditLink(photo.dataset.lightboxSource, photo.dataset.lightboxSourceUrl));
    }

    function showPhoto(photo) {
        cancelImage();
        media.replaceChildren();
        loading.hidden = true;
        noPhoto.hidden = Boolean(photo);
        error.hidden = true;
        direct.removeAttribute("href");
        showCredit(photo);

        if (!photo) return;

        loading.hidden = false;
        direct.href = photo.href;

        // A fresh element prevents a late response for an earlier day updating this one.
        var image = new Image();
        activeImage = image;
        image.className = "itinerary-lightbox__image";
        image.alt = photo.dataset.lightboxAlt || "";
        image.hidden = true;
        image.onload = function () {
            if (activeImage !== image) return;
            loading.hidden = true;
            image.hidden = false;
            modal.handleUpdate();
        };
        image.onerror = function () {
            if (activeImage !== image) return;
            loading.hidden = true;
            error.hidden = false;
            modal.handleUpdate();
        };
        media.replaceChildren(image);
        image.src = photo.href;
    }

    function scrollActiveDayIntoView() {
        var active = dayButtons[activeIndex];
        if (!active || !element.classList.contains("show")) return;
        active.scrollIntoView({ block: "nearest", inline: "nearest" });
    }

    function renderDay(index) {
        if (index < 0 || index >= days.length) return;
        activeIndex = index;
        var day = days[index];
        var sourceDetails = day.querySelector("[data-itinerary-day-details]");
        var photo = day.querySelector("[data-itinerary-photo]");

        title.textContent = headingFor(day);
        dayType.textContent = (day.dataset.dayIcon ? day.dataset.dayIcon + " " : "") + (day.dataset.dayType || "Itinerary");
        details.replaceChildren();
        if (sourceDetails && sourceDetails.children.length) {
            Array.from(sourceDetails.childNodes).forEach(function (node) {
                details.append(node.cloneNode(true));
            });
        } else {
            var empty = document.createElement("p");
            empty.className = "itinerary-lightbox__empty";
            empty.textContent = "No additional itinerary details are available for this day.";
            details.append(empty);
        }

        dayButtons.forEach(function (button, buttonIndex) {
            if (buttonIndex === index) button.setAttribute("aria-current", "step");
            else button.removeAttribute("aria-current");
        });

        previous.disabled = index === 0;
        next.disabled = index === days.length - 1;
        previous.setAttribute("aria-label", previous.disabled ? "Previous day" : "Previous day: " + headingFor(days[index - 1]));
        next.setAttribute("aria-label", next.disabled ? "Next day" : "Next day: " + headingFor(days[index + 1]));
        status.textContent = "Day " + (index + 1) + " of " + days.length;
        showPhoto(photo);
        scrollActiveDayIntoView();
        modal.handleUpdate();
    }

    function buildDayNavigation() {
        dayList.replaceChildren();
        dayButtons = days.map(function (day, index) {
            var button = document.createElement("button");
            var number = document.createElement("span");
            var dayTitle = document.createElement("span");
            button.type = "button";
            button.className = "itinerary-lightbox__day";
            button.setAttribute("aria-label", "Show " + headingFor(day));
            number.className = "itinerary-lightbox__day-number";
            number.textContent = "Day " + day.dataset.dayNumber;
            dayTitle.className = "itinerary-lightbox__day-title";
            dayTitle.textContent = labelFor(day);
            button.append(number, dayTitle);
            button.addEventListener("click", function () { renderDay(index); });
            dayList.append(button);
            return button;
        });
    }

    function initItineraryPhotos(root) {
        (root || document).querySelectorAll("[data-itinerary-photo]").forEach(function (link) {
        if (link.dataset.lightboxReady) return;
        link.dataset.lightboxReady = "true";
        link.setAttribute("aria-haspopup", "dialog");
        link.setAttribute("aria-controls", element.id);
        link.addEventListener("click", function (event) {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            var itinerary = link.closest(".tour-itinerary");
            var selectedDay = link.closest("[data-itinerary-day]");
            if (!itinerary || !selectedDay) return;

            trigger = link;
            returnScroll = { left: window.scrollX, top: window.scrollY, behavior: "instant" };
            days = Array.from(itinerary.querySelectorAll("[data-itinerary-day]"));
            buildDayNavigation();
            renderDay(days.indexOf(selectedDay));
            modal.show();
        });
        });
    }

    window.coachPotato = window.coachPotato || {};
    window.coachPotato.initItineraryPhotos = initItineraryPhotos;
    initItineraryPhotos(document);

    previous.addEventListener("click", function () { renderDay(activeIndex - 1); });
    next.addEventListener("click", function () { renderDay(activeIndex + 1); });

    element.addEventListener("shown.bs.modal", function () {
        scrollActiveDayIntoView();
        close.focus({ preventScroll: true });
    });
    element.addEventListener("hidden.bs.modal", function () {
        cancelImage();
        media.replaceChildren();
        details.replaceChildren();
        dayList.replaceChildren();
        days = [];
        dayButtons = [];
        activeIndex = -1;
        if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
        // Bootstrap releases the body scroll lock before this event. Restore the
        // exact reading position after focus changes inside the modal, without
        // inheriting the page's smooth-scroll behaviour.
        if (returnScroll) window.scrollTo(returnScroll);
    });
})();

// The maps bundle (MapLibre GL + tour-map.js, ~800KB) stays out of site.min.js and is loaded
// the first time a map is about to be seen: the homepage map or an itinerary card rendered
// open (?expand=) as it nears the viewport, or a card expanded later by tour-search.js. Exposed as coachPotato.loadMaps(), a
// memoised Promise; the bundle URLs ride on <body data-maps-js/data-maps-css> so they carry
// the file version. The stylesheet is awaited too, or MapLibre draws before its CSS lands.
(function () {
    "use strict";

    var pending = null;

    function load(element) {
        return new Promise(function (resolve, reject) {
            element.onload = resolve;
            element.onerror = reject;
            document.head.appendChild(element);
        });
    }

    function loadMaps() {
        if (pending) return pending;
        var data = document.body.dataset;
        if (!data.mapsJs) return Promise.reject(new Error("No maps bundle configured"));

        var parts = [];
        if (data.mapsCss) {
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = data.mapsCss;
            parts.push(load(link));
        }
        var script = document.createElement("script");
        script.src = data.mapsJs;
        parts.push(load(script));

        pending = Promise.all(parts).then(
            function () { return window.coachPotato; },
            function (error) { pending = null; throw error; });
        return pending;
    }

    // Resolves (with the loaded bundle) once any of `elements` comes within reach of the
    // viewport. A map below the fold — the homepage's sits under the search results — shouldn't
    // compete with the page's critical path.
    function loadMapsWhenNear(elements) {
        if (!("IntersectionObserver" in window)) return loadMaps();
        return new Promise(function (resolve) {
            var observer = new IntersectionObserver(function (entries) {
                if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
                observer.disconnect();
                resolve();
            }, { rootMargin: "400px" });
            Array.prototype.forEach.call(elements, function (el) { observer.observe(el); });
        }).then(loadMaps);
    }

    window.coachPotato = window.coachPotato || {};
    window.coachPotato.loadMaps = loadMaps;
    window.coachPotato.loadMapsWhenNear = loadMapsWhenNear;

    // Itinerary cards rendered open (?expand=): tour-map.js draws them once the bundle is in.
    function start() {
        var maps = document.querySelectorAll(".tour-map[data-tour-map]");
        if (maps.length === 0) return;
        loadMapsWhenNear(maps).catch(function () { /* no map; the rest of the page still works */ });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", start);
    } else {
        start();
    }
})();
